export const BUYER_PLAN_FEATURES = [
	{
		title: 'Overview',
		features: [
			{
				key: 'requestQuotation',
				title: 'สามารถกรอกข้อมูลเพื่อขอราคาจากโรงงานได้ (lock ไว้ไม่เกิน 5 เจ้า)',
				tooltip: 'สามารถกรอกข้อมูลเพื่อขอราคาจากโรงงานได้ (lock ไว้ไม่เกิน 5 เจ้า)',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'factorySelection',
				title: 'สามารถเลือกโรงงานได้ไม่จำกัด',
				tooltip: 'สามารถเลือกโรงงานได้ไม่จำกัด',
				standard: { status: true, word: '5 supplier / time' },
				business: { status: true, word: 'Unlimited' },
				enterprise: { status: true, word: 'Unlimited' },
			},
			{
				key: 'fiveKiloRadius',
				title: 'สามารถเลือกนอกรัศมี 5 กิโลเมตรได้',
				tooltip: 'สามารถเลือกนอกรัศมี 5 กิโลเมตรได้',
				standard: { status: true, word: '5 Km Radius' },
				business: { status: true, word: 'Unlimited' },
				enterprise: { status: true, word: 'Unlimited' },
			},
			{
				key: 'factoryFiltering',
				title:
					'สามารถสโคปฟิวเตอร์ เพื่อค้นหาโรงงานที่ตรงกับความต้องการได้ / ผู้ซื้อสามารถเลือกโรงงานที่ต้องการขอราคาเองได้',
				tooltip:
					'สามารถสโคปฟิวเตอร์ เพื่อค้นหาโรงงานที่ตรงกับความต้องการได้ / ผู้ซื้อสามารถเลือกโรงงานที่ต้องการขอราคาเองได้',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'showingAdvantage',
				title:
					'โชว์ icon showing advantage ข้อได้เปรียบของแต่ละโรงงานเพื่อเสริมการตัดสินใจของลูกค้า',
				tooltip:
					'โชว์ icon showing advantage ข้อได้เปรียบของแต่ละโรงงานเพื่อเสริมการตัดสินใจของลูกค้า',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'workshop3D',
				title: 'สามารถเข้าชมโรงงานผ่าน workshop 3D ได้',
				tooltip: 'สามารถเข้าชมโรงงานผ่าน workshop 3D ได้',
				standard: { status: true, word: 'รอพัฒนา' },
				business: { status: true, word: 'รอพัฒนา' },
				enterprise: { status: true, word: 'รอพัฒนา' },
			},
			{
				key: 'AiPdfDownloadable',
				title: 'สามารถดาวโหลดไฟล์เป็น AI, PDF ได้',
				tooltip: 'สามารถดาวโหลดไฟล์เป็น AI, PDF ได้',
				standard: { status: true, word: 'รอพัฒนา' },
				business: { status: true, word: 'รอพัฒนา' },
				enterprise: { status: true, word: 'รอพัฒนา' },
			},
		],
	},
	{
		title: 'Reporting and analytics',
		features: [
			{
				key: 'payment',
				title: 'สามารถชำระผ่านระบบ การโอนเงิน, การตัดบัตร credit card ได้',
				tooltip: 'สามารถชำระผ่านระบบ การโอนเงิน, การตัดบัตร credit card ได้',
				standard: { status: true, word: 'Basic' },
				business: { status: true, word: 'Advanced' },
				enterprise: { status: true, word: 'Advanced' },
			},
			{
				key: 'messaging',
				title: 'สามารถส่งข้อความถึงโรงงานได้',
				tooltip: 'สามารถส่งข้อความถึงโรงงานได้',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'favorite',
				title: 'สามารถกด favorite โรงงานให้โชว์ในหลังบ้าน (profile) ได้',
				tooltip: 'สามารถกด favorite โรงงานให้โชว์ในหลังบ้าน (profile) ได้',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'users',
				title: 'User ในระบบที่ใช้งานได้หลายคนพร้อมกัน โดยผูกกับ email',
				tooltip: 'User ในระบบที่ใช้งานได้หลายคนพร้อมกัน โดยผูกกับ email',
				standard: { status: true, word: '1 mail user' },
				business: { status: true, word: '1 mail user' },
				enterprise: { status: true, word: '3 mail users' },
			},
			{
				key: 'tasks',
				title: 'มีระบบการทำงานหลังบ้านที่สร้าง task ได้ (list, camban)',
				tooltip: 'มีระบบการทำงานหลังบ้านที่สร้าง task ได้ (list, camban)',
				standard: { status: true, word: 'รอพัฒนา' },
				business: { status: true, word: 'รอพัฒนา' },
				enterprise: { status: true, word: 'รอพัฒนา' },
			},
			{
				key: 'deliveryTime',
				title: 'โชว์ระยะเวลาตั้งแต่การรอ confirm จนถึงวันจัดส่ง',
				tooltip: 'โชว์ระยะเวลาตั้งแต่การรอ confirm จนถึงวันจัดส่ง',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'notification',
				title: 'ระบบแจ้งเตือน 1.ใบแจ้งขอราคา 2.ระบบยืนยันเปิดงาน 3.ระบบแจ้งเตือนใกล้ถึงวันจัดส่ง',
				tooltip: 'ระบบแจ้งเตือน 1.ใบแจ้งขอราคา 2.ระบบยืนยันเปิดงาน 3.ระบบแจ้งเตือนใกล้ถึงวันจัดส่ง',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
		],
	},
	{
		title: 'Support',
		features: [
			{
				key: 'agile-support-team',
				title: 'ทีมงาน Kumopack ให้คำแนะนำในการใช้งาน',
				tooltip: 'ทีมงาน Kumopack ให้คำแนะนำในการใช้งาน',
				standard: { status: false, word: null },
				business: { status: false, word: null },
				enterprise: { status: true, word: null },
			},
		],
	},
	{
		title: 'Promotion',
		features: [
			{
				key: 'accumulated points',
				title: 'คะแนนสะสมสำหรับโปรโมชั่นต่างๆในอนาคต',
				tooltip: 'คะแนนสะสมสำหรับโปรโมชั่นต่างๆในอนาคต',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
		],
	},
]

export const SUPPLIER_PLAN_FEATURES = [
	{
		title: 'Overview',
		features: [
			{
				key: 'registration',
				title: 'เปิดระบบเป็น Supplier กับ Platform',
				// tooltip: 'เปิดระบบเป็น Supplier กับ Platform',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'biddingOpportunity',
				title: 'ได้รับโอกาสในการ Bidding ราคาในทุกๆวัน',
				// tooltip: 'ได้รับโอกาสในการ Bidding ราคาในทุกๆวัน',
				standard: { status: true, word: 'Free 3 Months' },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'documentation',
				title: 'สามารถสร้างใบเสนอราคา, ใบแจ้งหนี้ และใบเสร็จรับเงินได้',
				// tooltip: 'สามารถสร้างใบเสนอราคา, ใบแจ้งหนี้ และใบเสร็จรับเงินได้',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'accountMember',
				title: 'User ในระบบที่ใช้งานได้หลายคนพร้อมกันโดยผูก Email',
				// tooltip: 'User ในระบบที่ใช้งานได้หลายคนพร้อมกันโดยผูก Email',
				standard: { status: true, word: '1 mail user' },
				business: { status: true, word: '3 mail users' },
				enterprise: { status: true, word: '5 mail users' },
			},
			// {
			// 	key: 'showingAdvantage',
			// 	title:
			// 		'โชว์ icon showing advantage ข้อได้เปรียบของเเต่ละโรงงานเพื่อเสริมการตัดสินใจของลูกค้า',
			// 	tooltip:
			// 		'โชว์ icon showing advantage ข้อได้เปรียบของเเต่ละโรงงานเพื่อเสริมการตัดสินใจของลูกค้า',
			// 	standard: { status: true, word: null },
			// 	business: { status: true, word: null },
			// 	enterprise: { status: true, word: null },
			// },
			// {
			// 	key: 'workshop3D',
			// 	title: 'สามารถเข้าชมโรงงานผ่าน workshop 3D ได้',
			// 	tooltip: 'สามารถเข้าชมโรงงานผ่าน workshop 3D ได้',
			// 	standard: { status: true, word: null },
			// 	business: { status: true, word: null },
			// 	enterprise: { status: true, word: null },
			// },
			// {
			// 	key: 'AiPdfDownloadable',
			// 	title: 'สามารถดาวโหลดไฟล์เป็น AI, PDF ได้',
			// 	tooltip: 'สามารถดาวโหลดไฟล์เป็น AI, PDF ได้',
			// 	standard: { status: false, word: null },
			// 	business: { status: true, word: null },
			// 	enterprise: { status: true, word: null },
			// },
		],
	},
	{
		title: 'Reporting and analytics',
		features: [
			{
				key: 'timelineForDelivery',
				title: 'โชว์ระยะเวลาตั้งแต่การรอ confirm จนถึงวันจัดส่ง',
				// tooltip: 'โชว์ระยะเวลาตั้งแต่การรอ confirm จนถึงวันจัดส่ง',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'notification',
				title: 'ระบบแจ้งเตือน 1.ใบเสนอราคา 2.ระบบยืนยันเปิดงาน 3.ระบบเเจ้งเตือนใกล้ถึงวันจัดส่ง',
				// tooltip: 'ระบบแจ้งเตือน 1.ใบเสนอราคา 2.ระบบยืนยันเปิดงาน 3.ระบบเเจ้งเตือนใกล้ถึงวันจัดส่ง',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'customerDataAnalytics',
				title:
					'แสดงข้อมูลที่เป็นประโยชน์ต่อโรงงานเพื่อการแข่งขัน เช่น ลูกค้าปิดงานด้วยหัวข้อ Showing Advantages แบบไหนจำนวนเท่าไหร่',
				// tooltip:
				// 	'แสดงข้อมูลที่เป็นประโยชน์ต่อโรงงานเพื่อการแข่งขัน เช่น ลูกค้าปิดงานด้วยหัวข้อ Showing Advantages แบบไหนจำนวนเท่าไหร่',
				standard: { status: false, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'deepDataForAnalysis',
				title: 'โชว์ suggestion ว่าการ base price ควรประมาณเท่าไหร่',
				// tooltip: 'โชว์ suggestion ว่าการ base price ควรประมาณเท่าไหร่',
				standard: { status: true, word: null },
				business: { status: true, word: null },
				enterprise: { status: true, word: null },
			},
			// {
			// 	key: 'tasks',
			// 	title: 'มีระบบการทำงานหลังบ้านที่สร้าง task ได้ (list, camban)',
			// 	tooltip: 'มีระบบการทำงานหลังบ้านที่สร้าง task ได้ (list, camban)',
			// 	standard: { status: false, word: null },
			// 	business: { status: true, word: null },
			// 	enterprise: { status: true, word: null },
			// },
			{
				key: 'agile-support-team',
				title: 'ทีมงาน Kumopack ให้คำแนะนำในการใช้งาน',
				// tooltip: 'ทีมงาน Kumopack ให้คำแนะนำในการใช้งาน',
				standard: { status: false, word: null },
				business: { status: false, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'special-content',
				title:
					'ทีมงาน KUMOPACK ถ่ายทำ presentation ของทางโรงงานเพื่อโปรโมทบนช่องทาง Blog และ Chanel ต่างๆ',
				// tooltip:
				// 	'ทีมงาน KUMOPACK ถ่ายทำ presentation ของทางโรงงานเพื่อโปรโมทบนช่องทาง Blog และ Chanel ต่างๆ',
				standard: { status: false, word: null },
				business: { status: false, word: null },
				enterprise: { status: true, word: null },
			},
			{
				key: 'free-banner',
				title: 'ได้ Banner ฟรี 1 ช่องตลอดทั้งเดือนใน 1 หมวด Category',
				// tooltip: 'ได้ Banner ฟรี 1 ช่องตลอดทั้งเดือนใน 1 หมวด Category',
				standard: { status: false, word: null },
				business: { status: false, word: null },
				enterprise: { status: true, word: null },
			},
		],
	},
]
